import { jsx as _jsx } from "tsx-dom/jsx-runtime";
/**
 * @returns The HTMLElement representing the context menu
 */
export function ContextMenuOverlay() {
    return (_jsx("div", { id: "context-menu-overlay", class: "hidden", children: _jsx("ul", { id: "context-menu" }) }));
}
